document.addEventListener("DOMContentLoaded", function() {
  console.log("DOM fully loaded.");

  document.getElementById("calculator-form").addEventListener("submit", function(event) {
    event.preventDefault(); // Prevent form reload
    console.log("Form submitted.");

    // Fetching inputs
    const length = parseFloat(document.getElementById("length").value);
    const width = parseFloat(document.getElementById("width").value);
    const height = parseFloat(document.getElementById("height").value);

    console.log("Inputs fetched:", { length, width, height });

    const glassWidth = parseFloat(document.getElementById("glassWidth").value) || 0;
    const glassHeight = parseFloat(document.getElementById("glassHeight").value) || 0;

    if (isNaN(length) || isNaN(width) || isNaN(height)) {
      document.getElementById("result").innerText = "Please enter valid numeric values.";
      return;
    }

    // Calculating sauna volume:
    const volume = length * width * height;
    let effectiveVolume = volume;

    const glassArea = glassWidth * glassHeight;
    effectiveVolume += glassArea * 1.5; // Each square meter of glass adds 1.5 m³ to the effective volume

    document.getElementById("result").innerText = `Effective Volume: ${effectiveVolume.toFixed(1)} m³`;

    const powerRating = effectiveVolume / 1.5;
    document.getElementById("result").innerText += ` Required Power Rating: ${powerRating.toFixed(2)} kW`;
  });
});
